import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import TextField from 'apollo-react/components/TextField';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import SaveConfirmationModal from './SaveConfirmationModal';
import { verifyReportModelExists } from '../../../../api/report-model-designer';
import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { saveReportModel } from '../../../actions/report-model-designer.actions';
import { validateProp } from '../../../utils/validation-report-model.utils';

const useStyles = makeStyles({
  modal: {
    width: 650,
  },
  confirmModal: {
    '& [class*="MuiDialogContent-root"]': {
      paddingBottom: 5,
    },
  },
});

const SaveAsModal = ({
  isOpen,
  initialReportName,
  handleClose,
  setIsLoading,
  redirectToReportModel,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();

  const [reportName, setReportName] = useState(initialReportName);
  const [error, setError] = useState({ hasError: false, errorText: '' });
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const saveReport = async () => {
    if (isConfirmModalOpen) {
      setIsConfirmModalOpen(false);
    }
    setIsLoading(true);

    await dispatch(saveReportModel({ isSaveAs: true, reportName, redirectToReportModel }));

    setIsLoading(false);
    handleClose();
  };

  const handleSaveProgressButton = async () => {
    const { resource: isReportExist } = await verifyReportModelExists(reportName);

    if (isReportExist) {
      setIsConfirmModalOpen(true);
    } else {
      saveReport();
    }
  };

  const handleReportNameFieldBlur = () => {
    const errorObj = validateProp({ propValue: reportName });
    setError(errorObj);
  };

  return (
    <>
      <Modal
        open={isOpen}
        variant="default"
        onClose={handleClose}
        title={translateString('Save As Report Model')}
        buttonProps={[
          {
            label: translateString('Cancel'),
          },
          {
            label: translateString('Save'),
            onClick: handleSaveProgressButton,
            disabled: error.hasError,
          },
        ]}
        className={classes.modal}
        disableBackdropClick
      >
        <TextField
          label={translateString('Report Model Name')}
          placeholder={translateString('Report Model Name...')}
          name="reportName"
          value={reportName}
          onChange={(e) => setReportName(e.target.value)}
          onBlur={handleReportNameFieldBlur}
          error={error.hasError}
          helperText={error.hasError ? translateString(error.errorText) : null}
          InputProps={{
            inputProps: {
              maxLength: 120,
            },
          }}
          fullWidth
          required
        />
      </Modal>

      {isConfirmModalOpen && (
        <SaveConfirmationModal
          onClose={() => setIsConfirmModalOpen(false)}
          onConfirm={saveReport}
          isOpen={isConfirmModalOpen}
          reportName={reportName}
        />
      )}
    </>
  );
};

export default SaveAsModal;
